module.exports = __webpack_public_path__ + "static/media/Geometria-Light.bcdee9b2.woff2";